import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import Logo from "../../components/Logo";

import { Pagination } from "swiper/modules";
import Input from "./components/Input";
import { AuthContext, useUserContext } from "../../Context/UserContext";
import { useState } from "react";
import { useContext } from "react";
import Popup from "../../components/Popup";
import { GoogleAuthProvider, unlink } from "firebase/auth";
import google from "../../assets/img/google.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const SignUp = () => {
  const navigate = useNavigate();
  const { creatUser } = useContext(AuthContext);
  const { providerLogin } = useContext(AuthContext);
  const { setRefetch } = useUserContext();
  const { login, logout } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [tab, setTab] = useState("google");
  const [password, setpassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorType, setErrorType] = useState("");
  const [googleLoading, setGoogleLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);

  const handleTermsChange = (e) => {
    setTermsAccepted(e.target.checked);
    if (e.target.checked) {
      setErrorMessage("");
      setErrorType("");
    }
  };

  const saveUserToBackend = async (jobData) => {
    const userResponse = await fetch(
      `${process.env.REACT_APP_SERVER_END_POINT}/post/user`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jobData),
      }
    );

    if (!userResponse.ok) {
      throw new Error(
        "Could not save your account. Make sure the server is running and try again."
      );
    }

    return userResponse;
  };

  const sendWelcomeEmail = async (email, firstName) => {
    try {
      await fetch(
        `${process.env.REACT_APP_SERVER_END_POINT}/api/welcome/sendEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, firstName }),
        }
      );
    } catch (error) {
      console.error("Welcome email failed:", error);
    }
  };

  const getGoogleAuthErrorMessage = (error) => {
    switch (error?.code) {
      case "auth/popup-closed-by-user":
        return "Sign up was cancelled. Please try again.";
      case "auth/cancelled-popup-request":
        return "Another sign-in popup is already open.";
      case "auth/account-exists-with-different-credential":
        return "An account already exists with this email using a different sign-in method.";
      default:
        return error?.message || "Google sign up failed. Please try again.";
    }
  };

  async function checkUserSignupMethod(email, firstName) {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_END_POINT}/user/signupMethod`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, firstName }),
      }
    );

    const data = await response.json(); // Parsing the JSON response

    if (!data.exists) {
      // Handle scenario where no user exists
    } else if (!data.signedUpWithGoogle) {
      setErrorMessage(
        "You have already signed up with this email,please Sigin using email and password from here "
      );

      setErrorType("EmailSignIn");
      return;

      // Handle scenario where user did not sign up with Google
    } else {
      // Handle scenario where user signed up with Google
    }
  }

  const handleGoogleSignIn = async () => {
    if (!termsAccepted) {
      setErrorMessage("Please accept the Terms of Service");
      return;
    }

    setGoogleLoading(true);
    setErrorMessage("");
    setErrorType("");

    try {
      const googleProvider = new GoogleAuthProvider();
      const result = await providerLogin(googleProvider);
      const user = result.user;
      const userEmail = user.email;
      const displayName = user.displayName;
      const photo = user.photoURL;

      const jobData = {
        words: 0,
        limitWords: 1000,
        email: userEmail.toLowerCase(),
        firstName: displayName,
        company: "",
        location: "",
        photo: photo,
        subscribed: false,
        productName: "Free",
        signupMethod: "Google",
      };

      await saveUserToBackend(jobData);
      sendWelcomeEmail(userEmail, displayName);

      setRefetch((prevref) => !prevref);
      navigate("/home");
    } catch (error) {
      console.error("Google sign up failed:", error);
      setErrorMessage(getGoogleAuthErrorMessage(error));
    } finally {
      setGoogleLoading(false);
    }
  };

  //google popup registration
  const handleLogin = async (event) => {
    if (firstName.length < 1) {
      setErrorMessage("Kindly provide your first name, please.");
      return;
    }
    if (lastName.length < 1) {
      setErrorMessage("Kindly provide your last name, please.");
      return;
    }

    if (email.length < 1) {
      setErrorMessage("Kindly provide your email, please.");
      return;
    }
    if (password.length < 1) {
      setErrorMessage("Kindly provide your password, please.");
      return;
    }

    if (!termsAccepted) {
      setErrorMessage("Please accept the Terms of Service");
      return;
    }

    setEmailLoading(true);
    setErrorMessage("");
    setErrorType("");

    try {
      const jobData = {
        words: 0,
        limitWords: 1000,
        email: email.toLowerCase(),
        firstName: firstName,
        lastName: lastName,
        company: "",
        location: "",
        amount_paid: 0,
        subscribed: false,
        customerId: "",
        productName: "Free",
        signupMethod: "emailAndPassword",
      };

      const userCredential = await creatUser(email, password);

      if (userCredential) {
        await saveUserToBackend(jobData);
        sendWelcomeEmail(email, firstName);
        logout();
        navigate("/login");
      } else {
        setErrorMessage("User creation failed. Please try again.");
      }
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        setErrorMessage("Email is already in use.");
      } else if (error.code === "auth/weak-password") {
        setErrorMessage("Password must be at least 6 characters.");
      } else {
        setErrorMessage(
          error.message || "Sign up failed. Please try again."
        );
      }
    } finally {
      setEmailLoading(false);
    }
  };

  return (
    <>
      <section className="register-section">
        <div className="row g-0">
          <div className="col-lg-6 d-none d-lg-block">
            <div className="register-left">
              <div className="register-left-inner">
                <Logo variant="white" />
                <div className="slide-wrapper">
                  <Swiper
                    slidesPerView={1}
                    modules={[Pagination]}
                    pagination={{ clickable: true, className: "ddd" }}
                  >
                    {[
                      {
                        title: "Start your Journey With US",
                        description:
                          "Embark on a transformative journey with R3achout.AI. This AI-driven web application is a game-changer in email creation for recruiters. Packed with a robust set of features, it's designed to refine your recruitment strategies and help you outshine your competition. Experience the ultimate recruitment copilot with R3achout.AI.",
                      },
                      {
                        title: "Maximize Your Time, Maximize Your Impact",
                        description:
                          "Time is of the essence in recruitment, and R3achout.AI is your ultimate recruitment sidekick. Created by recruiters, for recruiters, our tool empowers you to accomplish more in less time, significantly boosting your recruitment efficiency. Transform your approach and achieve better results with R3achout.AI.",
                      },
                      {
                        title: "Elevate Your Candidate Screening Process",
                        description:
                          "Screen candidates with unmatched proficiency using R3achout.AI. Our platform equips you with the insights and tools to ask the right questions, allowing you to thoroughly vet candidates and maintain an exceptional quality in your candidate pool. Be the expert in candidate assessment with R3achout.AI at your side.",
                      },
                    ].map((slide, i) => (
                      <SwiperSlide key={i}>
                        <div
                          className={`${
                            i === 2 ? "slide-item-elevate" : "slide-item"
                          }`}
                        >
                          <h4 className="title">{slide.title}</h4>
                          <p>{slide.description}</p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>

          {tab === "google" ? (
            <div className="col-lg-6 !flex !flex-col !items-center !justify-center  ">
              <div className="container  mb-20">
                <div className="register-wrapper">
                  <div className="auth-logo d-lg-none">
                    <Logo />
                  </div>
                  <div className="text-center">
                    <h3 className="auth-title">Register to R3achout.AI</h3>
                    <div className="auth-subtitle">
                      Create your account. It’s free, no credit card required
                      and only takes a few minutes.
                    </div>
                  </div>

                  <div className="mt-4 pt-lg-3">
                    <div className="login-wrapper pt-2   ">
                      <button
                        onClick={handleGoogleSignIn}
                        type="button"
                        disabled={googleLoading}
                        className="backup-login  !bg-[#23b574] text-white hover:!bg-white hover:!text-black transition ease-in-out duration-500  "
                      >
                        <img src={google} alt="" />{" "}
                        <span>
                          {googleLoading ? "Signing up..." : "Sign up with Google"}
                        </span>
                      </button>

                      <div className="d-flex flex-wrap justify-content-between mt-3">
                        <label className="form-check form--check flex-grow-1">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={termsAccepted}
                            onChange={handleTermsChange}
                          />

                          <span
                            className="form-check-label"
                            for="flexCheckChecked"
                          >
                            By clicking here,I state that I have
                            read,understood,and agree to the{" "}
                            <a href="/tos" target="_blank">
                              {" "}
                              Terms of Service
                            </a>
                          </span>
                        </label>
                      </div>

                      {errorMessage &&
                        (errorType === "EmailSignIn" ? (
                          <p className="my-3 mt-4 text-center text-base !font-semibold !text-red-500">
                            {errorMessage.slice(0, -5)}{" "}
                            <Link to="/login" className="text-blue-500">
                              here
                            </Link>
                            .
                          </p>
                        ) : (
                          <p className="my-3 mt-4 text-center text-base !font-semibold !text-red-500">
                            {errorMessage}
                          </p>
                        ))}
                    </div>

                    <div className="or ">
                      <span>Or Sign up with Email</span>
                    </div>

                    <button
                      // data-bs-toggle="modal"
                      data-bs-target="#job-save-pop"
                      onClick={() => {
                        setTab("email");
                        setErrorMessage("");
                      }}
                      className="backup-login font-[500] hover:bg-[#23b574] hover:text-white transition ease-in-out duration-500 "
                      type="submit"
                    >
                      Sign up with Email
                    </button>

                    <div className="mt-4 pt-lg-3 text-center alt-txt">
                      <span className="font-medium">
                        Already have an account? please
                      </span>{" "}
                      <Link to="/login" className="text-blue-500">
                        Login
                      </Link>
                    </div>
                  </div>

                  <div className="text-center mt-4 mt-xl-5 pt-4 ">
                    &copy;{new Date().getFullYear()} R3achout.AI all rights
                    reserved
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-lg-6 !flex !flex-col !items-center !justify-center  ">
              <div className="container  mb-20">
                <div className="register-wrapper">
                  <div className="auth-logo d-lg-none">
                    <Logo />
                  </div>
                  <div className="text-center">
                    <h3 className="auth-title">Register to R3achout.AI</h3>
                    <div className="auth-subtitle">
                      Create your account. It’s free, no credit card required
                      and only takes a few minutes.
                    </div>
                  </div>
                  <div className="w-full flex items-center mb-12 gap-3">
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      onClick={() => {
                        setTab("google");
                        setErrorMessage("");
                      }}
                      className="cursor-pointer"
                    />

                    <button
                      type="button"
                      onClick={() => {
                        setTab("google");
                        setErrorMessage("");
                      }}
                      className="font-semibold "
                    >
                      {" "}
                      Back
                    </button>
                  </div>

                  <div className="row mb-4">
                    <div className="col-6">
                      <Input
                        placeholder="Ex : John"
                        label="First Name"
                        required
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </div>
                    <div className="col-6">
                      <Input
                        placeholder="Doe"
                        label="Last Name"
                        required
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <Input
                      label="Email"
                      required
                      placeholder="example@mail.com"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="mb-4">
                    <Input
                      label="Password"
                      required
                      placeholder="**********"
                      type="password"
                      eye
                      onChange={(e) => setpassword(e.target.value)}
                    />
                  </div>
                  <div className="d-flex flex-wrap justify-content-between mt-3">
                    <label className="form-check form--check flex-grow-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={handleTermsChange}
                      />

                      <span className="form-check-label" for="flexCheckChecked">
                        By clicking here,I state that I have read,understood,and
                        agree to the{" "}
                        <a href="/tos" target="_blank">
                          {" "}
                          Terms of Service
                        </a>
                      </span>
                    </label>
                  </div>
                  <div className="mt-4 pt-lg-3">
                    <button
                      // data-bs-toggle="modal"
                      data-bs-target="#job-save-pop"
                      onClick={handleLogin}
                      disabled={emailLoading}
                      className="submit-btn"
                      type="submit"
                    >
                      {emailLoading ? "Registering..." : "Register Now"}
                    </button>
                  </div>

                  {/* {errorMessage && (
        <h4
          style={{ color: "red" }}
          className="my-3 mt-4 text-center text-base"
        >
          {errorMessage}{" "}
        </h4>
      )} */}

                  {errorMessage &&
                    (errorType === "EmailSignIn" ? (
                      <p className="my-3 mt-4 text-center text-base !font-semibold !text-red-500">
                        {errorMessage.slice(0, -5)}{" "}
                        <Link to="/login" className="text-blue-500">
                          here
                        </Link>
                        .
                      </p>
                    ) : (
                      <p className="my-3 mt-4 text-center text-base !font-semibold !text-red-500">
                        {errorMessage}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SignUp;
